import { Tag } from 'antd';

import type { MaterialMovementRow } from '../../redux/api/material-movements';
import { ACTION_META, actionLabel } from './movementMeta';

const ActionTag = ({ row }: { row: MaterialMovementRow }) => (
	<Tag color={ACTION_META[row.action]?.color} icon={ACTION_META[row.action]?.icon}>
		{actionLabel(row)}
	</Tag>
);

export default ActionTag;
